import { TokenService } from '@sphinx/leon-services'

const tokenService = new TokenService(localStorage)
export default tokenService
